"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUSState = void 0;
const lodash_1 = __importDefault(require("lodash"));
/*
 * ANSI FIPS State Code
 * [`Name`, `FIPS State Numeric Code`]
 * Keyed by  `Official USPS Code`
 */
const ISO = {
    AL: ['Alabama', 1],
    AK: ['Alaska', 2],
    AZ: ['Arizona', 4],
    AR: ['Arkansas', 5],
    CA: ['California', 6],
    CO: ['Colorado', 8],
    CT: ['Connecticut', 9],
    DE: ['Delaware', 10],
    DC: ['District of Columbia', 11],
    FL: ['Florida', 12],
    GA: ['Georgia', 13],
    HI: ['Hawaii', 15],
    ID: ['Idaho', 16],
    IL: ['Illinois', 17],
    IN: ['Indiana', 18],
    IA: ['Iowa', 19],
    KS: ['Kansas', 20],
    KY: ['Kentucky', 21],
    LA: ['Louisiana', 22],
    ME: ['Maine', 23],
    MD: ['Maryland', 24],
    MA: ['Massachusetts', 25],
    MI: ['Michigan', 26],
    MN: ['Minnesota', 27],
    MS: ['Mississippi', 28],
    MO: ['Missouri', 29],
    MT: ['Montana', 30],
    NE: ['Nebraska', 31],
    NV: ['Nevada', 32],
    NH: ['New Hampshire', 33],
    NJ: ['New Jersey', 34],
    NM: ['New Mexico', 35],
    NY: ['New York', 36],
    NC: ['North Carolina', 37],
    ND: ['North Dakota', 38],
    OH: ['Ohio', 39],
    OK: ['Oklahoma', 40],
    OR: ['Oregon', 41],
    PA: ['Pennsylvania', 42],
    RI: ['Rhode Island', 44],
    SC: ['South Carolina', 45],
    SD: ['South Dakota', 46],
    TN: ['Tennessee', 47],
    TX: ['Texas', 48],
    UT: ['Utah', 49],
    VT: ['Vermont', 50],
    VA: ['Virginia', 51],
    WA: ['Washington', 53],
    WV: ['West Virginia', 54],
    WI: ['Wisconsin', 55],
    WY: ['Wyoming', 56],
};
const isUSState = (code) => {
    return lodash_1.default.has(ISO, code);
};
exports.isUSState = isUSState;
exports.default = {
    isUSState: exports.isUSState,
};
//# sourceMappingURL=address.js.map